import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from "../src/pages/home"

import "swiper/css"

function App() {
  return (
    <div>
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path = "/homelight" element={< Homelight/>}/>
		    <Route path = "/homevideo" element={< Homevideo/>}/>
		    <Route path = "/homeparticle" element={< Homeparticle/>}/>
		    <Route path = "/homegrey" element={< Homegrey/>}/>
		    <Route path = "/homechef" element={< Homechef/>}/>
		    <Route path = "/homedesigner" element={< Homedesigner/>}/>
		    <Route path = "/homelawyer" element={< Homelawyer/>}/>
		    <Route path = "/homelightnew" element={< Homelightnew/>}/>
		    <Route path = "/homedarknew" element={< Homedarknew/>}/>
		    <Route path = "/homereveal" element={< Homereveal/>}/>
		    <Route path = "/homereveallight" element={< Homereveallight/>}/>
		    <Route path = "/homerevealdarknew" element={< Homerevealdarknew/>}/>
		    <Route path = "/homereveallightnew" element={< Homereveallightnew/>}/> */}
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
